import { motion } from 'framer-motion';

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, className = '', y = 26 }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
}

export function Container({ children, className = '' }) {
    return <div className={`mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-12 ${className}`}>{children}</div>;
}

export function Eyebrow({ children, light = false }) {
    return (
        <p className={`text-[11px] font-semibold uppercase tracking-[0.24em] ${light ? 'text-peri-300' : 'text-gold-700'}`}>
            {children}
        </p>
    );
}

export function SectionHeader({ eyebrow, title, sub, light = false, center = false }) {
    return (
        <Reveal className={`mb-10 md:mb-14 ${center ? 'text-center' : 'max-w-3xl'}`}>
            <Eyebrow light={light}>{eyebrow}</Eyebrow>
            <h2 className={`mt-3 font-serif text-3xl leading-tight tracking-tight sm:text-4xl lg:text-[2.75rem] ${light ? 'text-white' : 'text-ink'}`}>
                {title}
            </h2>
            {sub && <p className={`mt-4 text-base leading-relaxed md:text-lg ${light ? 'text-peri-200' : 'text-ink-muted'}`}>{sub}</p>}
        </Reveal>
    );
}

export function MaskedLines({ lines, className = '', delay = 0.05 }) {
    return (
        <h1 className={className}>
            {lines.map((line, i) => (
                <span key={i} className="block overflow-hidden pb-[0.08em]">
                    <motion.span
                        className="block"
                        initial={{ y: '112%' }}
                        animate={{ y: 0 }}
                        transition={{ duration: 0.95, delay: delay + i * 0.13, ease: EASE }}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </h1>
    );
}
